/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';
import { CONTACT_TYPE_FINCANCE_COMPANY } from '@gh/builder-shared-data';
import { createContextRoute } from '@gh/common-internal-shared';
import {
  ContactDetailsBusinessService,
  ContactDetailsFinanceCompanyCommonTabComponent,
  ContactDetailsSharedCommunicationListTabComponent,
  ContactDetailsSharedCustomFieldsTabComponent,
  ContactDetailsSharedTermsPayerTabComponent,
} from '../../index';
import { ContactDetailsModel } from '../../services/contact-details-model.service';
import { ContactDetailsFinanceCompanyFormState } from './contact-details-finance-company-form.service';

@Component({
  standalone: false,
  selector: 'gh-contact-details-finance-company-tab',
  templateUrl: 'contact-details-finance-company-tab.component.html',
})
export class ContactDetailsFinanceCompanyTabComponent {
  routes = [
    createContextRoute({
      component: ContactDetailsFinanceCompanyCommonTabComponent,
      path: 'common',
      init: {
        service: ContactDetailsBusinessService,
        selector: 'initFinanceCompanyCommonTabView',
      },
    }),

    createContextRoute({
      component: ContactDetailsSharedTermsPayerTabComponent,
      path: 'terms',
      init: {
        service: ContactDetailsBusinessService,
        selector: 'initSharedTermsPayerTabView',
      },
      static: {
        tab: 'financeCompany',
      },
    }),
    createContextRoute({
      component: ContactDetailsSharedCommunicationListTabComponent,
      path: 'communications',
      init: {
        service: ContactDetailsBusinessService,
        selector: 'initSharedCommunicationsTabView',
      },
      static: {
        tab: 'financeCompany',
        contactType: CONTACT_TYPE_FINCANCE_COMPANY,
      },
    }),
    createContextRoute({
      component: ContactDetailsSharedCustomFieldsTabComponent,
      path: 'customFields',
      static: {
        tab: 'financeCompany',
      },
    }),
  ];

  constructor(public model: ContactDetailsModel,
              public form: ContactDetailsFinanceCompanyFormState,
              public userContext: BuilderUserContext) {
  }

  get currentTab(): string {
    return <string>this.model.getSlaveTabFor('financeCompany');
  }

  onTabChanged(name: string): void {
    this.model.goToSubTab(name);
  }
}
